import sanitizeHtml from 'sanitize-html';

export const useSanitize = () => {
    /**
     * Sanitize HTML
     * @param html
     */
    const html = (html: string | null | undefined): string => {
        return sanitizeHtml(html ?? "", {
            allowedTags: [
                "p", "div", "span", "br", "strong", "small", "b", "em", "i", "u", "strike",
                "h1", "h2", "h3", "h4", "h5", "h6", "ul", "ol", "li", "dl", "dt", "dd",
                "a", "img", "table", "thead", "tbody", "tfoot", "tr", "th", "td",
                "sup", "sub", "caption", "quote", "figcaption", "figure", "hr", "iframe"
            ],
            allowedAttributes: {
                a: ["href", "target", "title"],
                img: ["src", "srcset", "alt", "title", "width", "height", "loading"],
                iframe: ["src", "title", "frameborder", "allow", "allowfullscreen", "width", "height", "loading", "referrerpolicy"],
            },
            allowedIframeHostnames: ['www.youtube.com', 'www.youtube-nocookie.com'],
            allowedSchemes: ['http', 'https', 'mailto', 'tel'],
        });
    };

    return {
        html,
    };
};
